<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
</script>

<template>
  <Box align="center" gap="3" class="notif-skeleton">
    <Box class="notif-skeleton__icon" />
    <Box direction="col" gap="2" grow class="notif-skeleton__lines">
      <Box class="notif-skeleton__bar notif-skeleton__bar--title" />
      <Box class="notif-skeleton__bar notif-skeleton__bar--body" />
      <Box class="notif-skeleton__bar notif-skeleton__bar--meta" />
    </Box>
  </Box>
</template>

<style scoped>
.notif-skeleton {
  padding: 0.875rem 1.25rem;
  background: var(--p-surface-0);
  border-top: 1px solid var(--p-surface-100);
}

.notif-skeleton__icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: var(--p-surface-100);
  flex-shrink: 0;
  animation: notif-skeleton-pulse 1.4s ease-in-out infinite;
}

.notif-skeleton__lines {
  min-width: 0;
}

.notif-skeleton__bar {
  height: 10px;
  background: var(--p-surface-100);
  border-radius: 4px;
  animation: notif-skeleton-pulse 1.4s ease-in-out infinite;
}

.notif-skeleton__bar--title {
  width: 60%;
}

.notif-skeleton__bar--body {
  width: 90%;
}

.notif-skeleton__bar--meta {
  width: 30%;
  height: 8px;
}

.notif-skeleton__bar--body {
  animation-delay: 0.15s;
}

.notif-skeleton__bar--meta {
  animation-delay: 0.3s;
}

@keyframes notif-skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
</style>
